export enum UserRole {
    BUYER = 'buyer',
    SELLER = 'seller',
    ADMIN = "admin",
    ORDER_MANAGER = "order_manager"
}